document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('.block-container');

  if (containers.length === 0) return;

  containers.forEach(container => {
    const accordions = container.querySelectorAll('.component-accordion__accordion');

    accordions.forEach((accordion, index) => {
      const heading = accordion.querySelector('.component-accordion__accordion__heading');
      const content = accordion.querySelector('.component-accordion__accordion__content');

      if (!heading || !content) return;

      // Initially open only the first accordion, close the rest
      if (index === 0) {
        content.style.maxHeight = content.scrollHeight + 'px';
      } else {
        content.style.maxHeight = '0px';
      }

      heading.addEventListener('click', () => {
        const isOpen = content.style.maxHeight !== '0px';

        // Close all
        accordions.forEach(otherAccordion => {
          const otherContent = otherAccordion.querySelector('.component-accordion__accordion__content');
          if (otherContent) {
            otherContent.style.maxHeight = '0px';
          }
        });

        // Open current if it wasn't already open
        if (!isOpen) {
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      });
    });
  });
});
